import React, { useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router";
import socket from "../../assets/socketConnection";
import { toPersianNum, toSeperatedNum } from "../../assets/utils";
import ShowRate from "../../components/ShowRate/ShowRate.component";
import PriceConflictIcon from "../../assets/img/icn_Conflict.svg";
import {
  setAlertPageFirstBtn,
  setAlertPageFirstBtnFunc,
  setAlertPageMessage,
  toggleAlertPageIsVisible,
} from "../../redux/alertPage/alertPage.actions";
import { fetchCurrentCardAsync } from "../../redux/currentReq/currentReq.actions";
// import { selectCurrentReqInfo } from "../../redux/currentReq/currentReq.selectors";
import { BitsSingleStyled, ConflictIcon } from "./bitsSingle.styles";
import ModalCandidateDriver from "../modalCandidateDriver/modalCandidateDriver.component";

const BitsSingle = ({
  bit,
  isMyReq,
  setAlertPageMessage,
  setAlertPageFirstBtn,
  setAlertPageFirstBtnFunc,
  toggleAlertPageIsVisible,
  load_data,
  fetchCurrentCardAsync,
}) => {
  const [candidateDriver, setCandidateDriver] = useState();
  const [visible, setVisible] = useState(false);
  const showModal = () => {
    setVisible(true);
  };
  const { id, _driver_id, price, more_detail, our_suggest } = bit;
  const { shown_tariff } = load_data;
  // console.log(isMyReq);
  // console.log(bit);
  // console.log(data);
  const params = useParams();
  // debugger;

  // const browserHistory = useHistory();

  // debugger;

  // socket.on("response_check_driver_candidate", (data) => {
  //   // LOADS_STATE.response_check_driver_candidate = data;
  //   // console.log(LOADS_STATE.response_check_driver_candidate);
  //   alert("response check driver");
  //   console.log(data);
  //   debugger;
  //   // updateCheckDriverPage();
  //   // checkDriverPage.classList.remove("hide");
  // });
  const CheckDriverCandidate = () => {
    socket.emit("check_driver_candidate", { bit_id: id });
    socket.on("response_check_driver_candidate", (res) => {
      console.log("check_driver_candidate", res);
      setCandidateDriver(res);
    });
    showModal();
  };

  const handle_selectDriver_click = () => {
    const func = () => {
      // console.log(bit.id);
      // debugger;
      // browserHistory.go(0);

      // socket.emit("get_loads", {

      //   filter: { pageId },
      // });
      socket.emit("set_driver_candidate", { bit_id: id });
      setTimeout(() => {
        fetchCurrentCardAsync(socket, params.id);
      }, 3000);
    };

    setAlertPageMessage("آیا از انتخاب راننده مطمئنید؟");
    setAlertPageFirstBtn("بله");
    setAlertPageFirstBtnFunc(func);
    toggleAlertPageIsVisible();
  };

  const handle_reqOff_click = () => {
    // alert("hi");
    const func = () => {
      // console.log(bit.id);
      // debugger;
      socket.emit("request_discount", { bit_id: id });
    };

    setAlertPageMessage("آیا از ارسال درخواست تخفیف مطمئنید؟");
    setAlertPageFirstBtn("بله");
    setAlertPageFirstBtnFunc(func);
    toggleAlertPageIsVisible();
  };

  return (
    <BitsSingleStyled>
      <div className="d-flex align-items-center justify-content-between">
        <div>
          {_driver_id.firstname} {_driver_id.lastname}
        </div>
        <div>
          <ShowRate rank={_driver_id.rank} />
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between">
        <div>
          <span>{_driver_id.drivervehicle.vehicle.v_name}</span>
          <span> {_driver_id.drivervehicle.vehicle_category.t_name}</span>
        </div>
        <div>
          {our_suggest.is_our_suggestion ? (
            <button className="btn--golden">پیشنهاد بارنت</button>
          ) : null}
        </div>
      </div>

      <div className="bit__price">
        {shown_tariff &&
        Boolean(shown_tariff.suggested_price) &&
        price != shown_tariff.suggested_price ? (
          <ConflictIcon src={PriceConflictIcon}></ConflictIcon>
        ) : (
          ""
        )}
        <span>قیمت پیشنهادی:‌ </span>
        <span>{toSeperatedNum(toPersianNum(price))} </span>
        <span>تومان</span>
      </div>

      <div className="mt-2 font-size--n1" style={{ opacity: "0.7" }}>
        {more_detail}
      </div>

      {isMyReq && (
        <div className="d-flex align-items-center justify-content-between mt-2">
          <div>
            <button className="btn--red font-size--n2">گزارش</button>
          </div>
          <div className="d-flex align-items-center font-size--n2">
            <div>
              <button
                className="btn--dark-outline ml-2"
                onClick={handle_reqOff_click}
              >
                درخواست تخفیف
              </button>
            </div>
            <div>
              <button className="btn--dark" onClick={CheckDriverCandidate}>
                انتخاب راننده
              </button>
              <ModalCandidateDriver
                visible={visible}
                setVisible={setVisible}
                Data={candidateDriver}
                func={handle_selectDriver_click}
              />
            </div>
          </div>
        </div>
      )}
    </BitsSingleStyled>
  );
};
const mapStateToProps = null;

const mapDispatchToProps = (dispatch) => ({
  setAlertPageMessage: (x) => dispatch(setAlertPageMessage(x)),
  setAlertPageFirstBtn: (x) => dispatch(setAlertPageFirstBtn(x)),
  setAlertPageFirstBtnFunc: (x) => dispatch(setAlertPageFirstBtnFunc(x)),
  toggleAlertPageIsVisible: (x) => dispatch(toggleAlertPageIsVisible(x)),

  fetchCurrentCardAsync: (x, y) => dispatch(fetchCurrentCardAsync(x, y)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BitsSingle);
